<template>
  <DsShowcase title="AvatarPlay" description="Avatar circular com suporte a imagem, iniciais por nome, tamanhos predefinidos e cores aleatórias.">
    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl'</code></p>
      <div class="tw:flex tw:items-end tw:gap-4 tw:flex-wrap">
        <div v-for="s in sizes" :key="s" class="tw:flex tw:flex-col tw:items-center tw:gap-2">
          <AvatarPlay :size="s" name="João Silva" />
          <span class="tw:text-[10px] tw:opacity-50">{{ s }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: src -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">src</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — URL da imagem</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <AvatarPlay src="https://i.pravatar.cc/150?img=1" size="3xl" />
        <AvatarPlay src="https://i.pravatar.cc/150?img=5" size="3xl" />
        <AvatarPlay src="https://i.pravatar.cc/150?img=12" size="3xl" />
        <AvatarPlay src="https://i.pravatar.cc/150?img=32" size="3xl" />
      </div>
    </section>

    <!-- PROP: name -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">name</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — gera iniciais quando não há imagem. Cor de fundo aleatória.</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <AvatarPlay name="Ana Maria" size="3xl" />
        <AvatarPlay name="Bruno" size="3xl" />
        <AvatarPlay name="Carlos Eduardo" size="3xl" />
        <AvatarPlay name="Diana Souza" size="3xl" />
      </div>
    </section>

    <!-- PROP: customSize -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">customSize</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — tamanho customizado em CSS (sobrescreve size)</p>
      <div class="tw:flex tw:items-end tw:gap-4 tw:flex-wrap">
        <AvatarPlay name="Custom" custom-size="80px" />
        <AvatarPlay name="Custom" custom-size="120px" />
      </div>
    </section>

    <!-- PROP: customBgColor -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">customBgColor</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — cor de fundo customizada (sobrescreve a cor aleatória)</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <AvatarPlay name="AB" size="3xl" custom-bg-color="#e53e3e" />
        <AvatarPlay name="CD" size="3xl" custom-bg-color="#3182ce" />
        <AvatarPlay name="EF" size="3xl" custom-bg-color="#38a169" />
        <AvatarPlay name="GH" size="3xl" custom-bg-color="#7c3aed" />
      </div>
    </section>

    <!-- PROP: skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <AvatarPlay :skeleton="true" size="2xl" />
        <AvatarPlay :skeleton="true" size="3xl" />
        <AvatarPlay :skeleton="true" size="4xl" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { AvatarPlay } from '@/components/atomic'

const sizes = ['xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'] as const
</script>
